module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1chapter01"
    }
  }, [_vm._v("PART I: THE TABLETS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1chapter02"
    }
  }, [_vm._v("THE SHAME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part2chapter01"
    }
  }, [_vm._v("PART II: THE SECOND MASSACHUSETTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part2chapter02"
    }
  }, [_vm._v("PRIVATE OTIS PIKE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part2chapter03"
    }
  }, [_vm._v("LIEUTENANT COLONEL MUDGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part3chapter01"
    }
  }, [_vm._v("PART III: THE ARCHIVES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part3chapter02"
    }
  }, [_vm._v("THE BLANK PAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part4chapter01"
    }
  }, [_vm._v("PART IV: OTIS SKEDADDLES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part4chapter02"
    }
  }, [_vm._v("SEEING THE ELEPHANT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOMETHING MAGNIFICENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A LONG NIGHT FOR OTIS PIKE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE WORD OF GOD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part5chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART V: THE HONOR OF THE FAMILY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part5chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A STUDY OF WHISKERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part5chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UP-ATTIC")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part6chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART VI: SKEDADDLING AGAIN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part6chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURE HAPPINESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part6chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OLD HARVARD CHUMS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part6chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EUSTIS AND FARRAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part6chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OTIS, WHERE WERE YOU?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part7chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART VII: THE FIELD OF BATTLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part7chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STRANGELY BEAUTIFUL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part7chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SHOP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part8chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART VIII: THE SLAUGHTERHOUSE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part8chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IT WAS THE GENERALS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part8chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MORNING REPORT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part9chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IX: THE NUTTINESS OF EBENEZER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part9chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE HAIR PRESUMPTIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part9chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ONCE AGAIN, HER FACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART X: IDA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SURGEON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A TIDY LITTLE VILLAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IDA ON THE BATTLEFIELD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MR. BUSHMAN’S BARN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE DEAD OF THE TWELFTH CORPS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE EMBALMING SURGEON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LIEUTENANT GOBRIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MY DEAR DAUGHTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TO BALTIMORE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part11chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART XI: THE BLOODSTAINED COAT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part11chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE GUN THAT WON THE WAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part11chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE POCKETS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part11chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EBENEZER’S TRASH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part12chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART XII: LILY LEBEAU")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part12chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A LITTLE PIECE OF BAD NEWS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part12chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CALM THY FEARS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part12chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HER WIFELY DEVOTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part12chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE BURIAL PARTY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part12chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANOTHER SKEDADDLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part13chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART XIII: OUT OF THE DARK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part13chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FAMILY ALBUM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part13chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GLORIOUS LIBRARIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part14chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART XIV: THE MARBLE HEART")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part14chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NO WIFELY CLAIM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part14chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A LETTER FROM EUDOCIA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part14chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BABIES THAT GET STUCK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part14chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AROUND THE PIANO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part14chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A GIGANTIC FIREARM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part15chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART XV: THE CONCORD ROSEBUD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part15chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A TRIFLE FISHY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part15chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SCRAPBOOK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part16chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART XVI: FINDING LILY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part16chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE B&O")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part16chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IDA FORLORN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part16chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE NEW SHAPE OF THE WORLD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part16chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE LIVING STATUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part16chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IDA’S DRAWERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part16chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE HOSPITALS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part16chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOMEONE KNOCKING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part17chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART XVII: INVITED BACK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part17chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TOO FANTASTIC")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part17chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SMASHED GLASS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part18chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART XVIII: THE PATENT OFFICE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part18chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SURPRISING PATIENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part18chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CAMPED NEAR A SLOUGH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part18chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“OH MY!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part18chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SEWING MACHINE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part19chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART XIX: THE LAST SKEDADDLE OF OTIS PIKE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part19chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE NEEDLE’S EYE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part19chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE QUESTION MARKS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part19chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THREE STITCHES OF DOUBLE CROCHET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part19chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DARLING IDA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part19chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLABBERGASTING DEDUCTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part20chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART XX: THE AGREEMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part20chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SMOKING CAP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part21chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART XXI: UNBOUND REGIMENTAL PAPERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part21chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOD BLESS THE ARCHIVISTS AND ALL THE LIBRARIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part21chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MISCELLANEOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part21chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOBRIGHT’S REPORT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part21chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OUTPOSTS OF THE CRANIUM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part21chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE GREAT ROLL CALL IN THE SKY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part21chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRESH AND BLEEDING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part21chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FLOWER OF THE NATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part21chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE HORRID BANG")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part21chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VARIOUS PATRIOTIC REMARKS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part21chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AFTERWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/teaser00",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preview: "), _c('i', [_vm._v("Steeplechase")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 81
// module chunks = 0